import type { TRequestSocketStep } from '@/shared/types/request-socket.types';

export const REQUEST_PROGRESS_SOCKET_EVENT = 'request_progress';

export const PAYMENT_SCHEDULE_UPDATED_SOCKET_EVENT = 'payment_schedule_updated';

export const REQUEST_SOCKET_STEPS: TRequestSocketStep[] = [
  'underwriter_approved',
  'underwriter_rejected',
  'decision_accepted',
  'awaiting_financing',
  'documents_ready',
  'contract_signed',
  'down_payment_method_changed',
  'down_payment_paid',
  'vehicle_registered',
  'telemetry_installed',
  'issued'
];

export const REQUEST_SOCKET_DASHBOARD_REFRESH_STEPS: TRequestSocketStep[] = [
  'contract_signed',
  'down_payment_method_changed',
  'down_payment_paid',
  'vehicle_registered',
  'telemetry_installed',
  'issued'
];
